import { faArrowRotateRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  renderSortableColumn,
  renderSetFilterInputColumn,
  renderSetFilterSelectColumn,
} from "./ColumnManager";
import DownloadDocIdsCSV from "./FileDownloadManager";

export const renderFilterCellDocs = (
  col,
  idx,
  context
) => {
  switch (col.FilterType) {
    case "select": {
      const { colorFilterAction, filter, setFilter, t } = context;

      const customSelectOptions = {
        Complexite: [
          { value: "", label: t("All") },
          { value: "Simple", label: t("Simple") },
          { value: "Moyen", label: t("Medium") },
          { value: "Complexe", label: t("Complexe") },
        ],
        bValid: [
          { value: "", label: t("All") },
          { value: "true", label: t("True") },
          { value: "false", label: t("False") },
        ],
        isvalid: [
          { value: "", label: t("All") },
          { value: "true", label: t("True") },
          { value: "false", label: t("False") },
        ],
      }; // Select avec différents options

      if (customSelectOptions[col.key]) {
        return (
          <th
            key={`filter-select-${col.key}-${idx}`}
            style={{ backgroundColor: colorFilterAction }}
          >
            <select
              className="form-select style_select"
              onChange={(e) =>
                setFilter({
                  ...filter,
                  [col.key]: e.target.value,
                })
              }
            >
              {customSelectOptions[col.key].map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </th>
        );
      }

      const options = context.uniqueValuesByKey?.[col.key];
      return renderSetFilterSelectColumn(
        context,
        col.key,
        options,
        col.key,
        col.label
      );
    }

    case "input":
      return renderSetFilterInputColumn(
        context,
        col.key,
        col.colSpan,
        col.placeHolder,
        col.filterKey
      );

    case "sort":
      return renderSortableColumn(context, col.key, col.key);

    case "ActionFilter":
      return (
        <th
          key={`filter-action-${idx}`}
          style={{
            backgroundColor: context.colorFilterAction,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "center" }}>
            <DownloadDocIdsCSV data={context.data} selectedDocuments={context.selectedDocuments} />

            <button
              data-toggle="tooltip"
              title={context.t("Reset filters")}
              onClick={context.handleResetFilters}
              className="btn bg-light text-hover-blue"
            >
              RAZ
            </button>
            <button
              data-toggle="tooltip"
              title={context.t("Reload page")}
              className="btn bg-light"
              onClick={() => window.location.reload(false)}
            >
              <FontAwesomeIcon icon={faArrowRotateRight} className="fa-copy" />
            </button>
          </div>
        </th>
      );

    default:
      return (
        <th
          key={`filter-default-${idx}`}
          className="style_tbody_th"
          style={{ backgroundColor: context.colorFilterAction }}
        ></th>
      );
  }
};
